module.exports = __webpack_public_path__ + "static/people_img22-bfc67e20e6a70b09e0d7a6080b6d0e30.png";